
















































































































import { SfLoader } from "@storefront-ui/vue";
import {
  defineComponent,
  ref,
  watchEffect,
  computed,
  PropType,
} from "@nuxtjs/composition-api";
import { TrackingOrderResults } from "~/modules/customer/composables/useUserOrder/useUserOrder";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import { convertTime } from "~/helpers/index";
import { statusStyle } from "~/modules/pageExten/helpers/checkOrder";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

export default defineComponent({
  name: "OrderTracking",
  components: {
    SkeletonLoader,
  },
  props: {
    trackingData: {
      type: Object as PropType<TrackingOrderResults>,
      required: true,
    },

  },
  setup(props) {
    const tracking = computed(() => props?.trackingData.data);
    const viewMore = ref(true);
    const classViewMore = ref("");

    const changeTime = (time) => {
      return dayjs(time).tz("Asia/Ho_Chi_Minh").format("DD/MM/YYYY - HH:mm");
    };

    const statusData = (status) => {
      return statusStyle(status).trackingStyle;
    };

    const clickViewMore = () => {
      if (!viewMore.value) {
        viewMore.value = true;
        classViewMore.value = "more active";
      } else {
        viewMore.value = false;
        classViewMore.value = "more";
      }
    };

    const goToLink = (url) => {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.click();
    };

    return {
      tracking,
      viewMore,
      changeTime,
      statusStyle,
      statusData,
      goToLink,
      clickViewMore,
      classViewMore,
    };
  },
});
